let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ex9RG")).then(() => parcelRequire('aJCau'));